import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditReportSubjectPage.css';
import ReportForm from '../../../components/report/ReportForm/ReportForm';
import { fetchReportSubject, putReportSubject } from '../../../store/reportsubjects/actions';
import { REPORTSUBJECT_PAGE } from '../../../constants/routes';
import withTranslation from '../../../hoc/withTranslation';

export class EditReportSubjectPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchReportSubject();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.reportSubject) {
            let url = REPORTSUBJECT_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':reportsubjectId', nextProps.reportSubject.id);
            this.props.history.push(url);
        }
    }

    // Fetch

    fetchReportSubject(appId = null, reportSubjectId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const reportSubject = reportSubjectId || this.props.match.params.reportsubjectId;

            if (app && reportSubject) {
                this.props.fetchReportSubject(app, reportSubject);
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putReportSubject(this.props.app.id, formProps);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.reportSubject) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t(
                        'module.report.report_subject_edit',
                        { name: this.props.app.name },
                    )}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>{this.props.reportSubject.name}</Subheader>

                                <div style={style.paper}>
                                    <ReportForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                        initialValues={this.props.initialValues}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.reportsubjects.pending,
        error: state.apps.error,
        reportSubject: state.reportsubjects.currentSubject,
        app: state.apps.currentApplication,
        sending: state.reportsubjects.sending,
    };

    if (state.reportsubjects.currentSubject) {
        props.initialValues = state.reportsubjects.currentSubject;
    }

    return props;
}

export default connect(mapStateToProps, {
    putReportSubject,
    fetchApp,
    fetchReportSubject,
})(withTranslation(EditReportSubjectPage));



// WEBPACK FOOTER //
// src/containers/reportsubjects/EditReportSubjectPage/EditReportSubjectPage.js